<script>
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import {useSecurityStore} from "@/stores/Security";

export default {
    setup() {
        const {$i18n, $router, $route} = useTools();
        const securityStore = useSecurityStore();

        const items = ref([
            {
                action: "mdi-cog-outline",
                title: "Générale",
                access: securityStore.authorities['READ_GENERAL_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "general_configuration",
                        active: "general_configuration" === $route.name,
                    },
                    /*{
                        title: "Gestion des Dossier",
                        action: "mdi-folder-cog",
                        link: "folders",
                        access: true,
                        active: "folders" === $route.name,
                    },*/
                    {
                        title: "Référence Automatique",
                        action: "mdi-code-braces",
                        link: "codifications",
                        active: "codifications" === $route.name,
                    },
                    {
                        title: $i18n.t("module.data_select"),
                        action: "mdi-cable-data",
                        link: "data_selects",
                        active: "data_selects" === $route.name,
                    },
                    {
                        title: $i18n.t("module.additional_fields"),
                        action: "mdi-form-dropdown",
                        link: "additional_fields",
                        active: "additional_fields" === $route.name,
                    },
                    {
                        title: $i18n.t("module.email"),
                        action: "mdi-email-newsletter",
                        link: "emails",
                        active: "emails" === $route.name,
                    },
                ]
            },
            {
                action: "mdi-tools",
                title: "Importations",
                access: securityStore.authorities['READ_IMPORT_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.cnas_agency_tools"),
                        action: "mdi-domain",
                        link: "cnas_agency_tools",
                        active: "cnas_agency_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.occupations_tools"),
                        action: "mdi-android-studio",
                        link: "occupation_tools",
                        active: "occupation_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.workers_tools"),
                        action: "mdi-account-tie-outline",
                        link: "worker_tools",
                        active: "worker_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.contrat_template_tools"),
                        action: "mdi-book-cog",
                        link: "contrat_template_tools",
                        active: "contrat_template_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.contrat_tools"),
                        action: "mdi-book-open-page-variant",
                        link: "contrat_tools",
                        active: "contrat_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.debt_tools"),
                        action: "mdi-cash-multiple",
                        link: "debt_tools",
                        active: "debt_tools" === $route.name,
                    },
                    /*{
                        title: $i18n.t("module.evaluation_measures_tools"),
                        action: "mdi-domain",
                        link: "evaluation_measures_tools",
                        active: "evaluation_measures_tools" === $route.name,
                    },*/
                    {
                        title: $i18n.t("module.evaluation_files_tools"),
                        action: "mdi-bullseye-arrow",
                        link: "evaluation_files_tools",
                        active: "evaluation_files_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.pay_section_tools"),
                        action: "mdi-bookshelf",
                        link: "pay_section_tools",
                        active: "pay_section_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.pay_slip_tools"),
                        action: "mdi-account-credit-card",
                        link: "pay_slip_tools",
                        active: "pay_slip_tools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.assigned_pay_section_tools"),
                        action: "mdi-clipboard-text-clock",
                        link: "assigned_pay_section_tools",
                        active: "assigned_pay_section_tools" === $route.name,
                    },
                    /*{
                        title: $i18n.t("module.irgs_tools"),
                        action: "mdi-cash",
                        link: "irg_tools",
                        active: "irg_tools" === $route.name,
                    },*/
                ],
            },
            {
                action: "mdi-account-convert",
                title: "Recrutement",
                access: securityStore.authorities['READ_RECRUITMENT_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "recruitments_configuration",
                        active: "recruitments_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.process_model"),
                        action: "mdi-sitemap",
                        link: "boarding_process_models",
                        active: "boarding_process_models" === $route.name,
                    },
                    {
                        title: $i18n.t("module.task_model"),
                        action: "mdi-timer-edit-outline",
                        link: "boarding_task_models",
                        active: "boarding_task_models" === $route.name,
                    },
                ],
            },
            {
                action: "mdi-circle-double",
                title: "Administration",
                access: securityStore.authorities['READ_ADMIN_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "workers_configuration",
                        active: "workers_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.cnas_agency"),
                        action: "mdi-domain",
                        link: "cnas_agencies",
                        active: "cnas_agencies" === $route.name,
                    },
                    {
                        title: $i18n.t("module.occupations"),
                        action: "mdi-android-studio",
                        link: "occupations",
                        active: "occupations" === $route.name,
                    },
                ],
            },
            {
                action: "mdi-auto-fix",
                title: "Paie",
                access: securityStore.authorities['READ_PAY_SLIP_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "pay_slips_configuration",
                        active: "pay_slips_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.pay_sections"),
                        action: "mdi-bookshelf",
                        link: "pay_sections",
                        active: "pay_sections" === $route.name,
                    },
                    {
                        title: "Rubriques par Défaut",
                        action: "mdi-book-open-variant",
                        link: "default_pay_sections",
                        active: "default_pay_sections" === $route.name,
                    },
                    {
                        title: $i18n.t("module.auto_pay_sections"),
                        action: "mdi-auto-fix",
                        link: "auto_pay_sections",
                        active: "auto_pay_sections" === $route.name,
                    },
                    {
                        title: "Modèle Export/Imporation",
                        action: "mdi-relation-many-to-many",
                        link: "import_models",
                        active: "import_models" === $route.name,
                    },
                    {
                        title: $i18n.t("module.out_state_model"),
                        action: "mdi-state-machine",
                        link: "out_state_models",
                        active: "out_state_models" === $route.name,
                    },
                    {
                        title: $i18n.t("module.bank"),
                        action: "mdi-bank",
                        link: "banks",
                        active: "banks" === $route.name,
                    },
                    /*{
                        title: $i18n.t("module.external_sources"),
                        action: "mdi-source-branch",
                        link: "external_sources",
                        access: true,
                        active: "external_sources" === $route.name,
                    },*/
                ],
            },
            {
                action: "mdi-sitemap",
                title: "Demande",
                access: securityStore.authorities['READ_ABSENCE_REQUEST_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "validation_work_flows_configuration",
                        active: "validation_work_flows_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.balances"),
                        action: "mdi-white-balance-sunny",
                        link: "balances",
                        active: "balances" === $route.name,
                    },
                    {
                        title: $i18n.t("module.absence_reasons"),
                        action: "mdi-power-plug-off",
                        link: "absence_reasons",
                        active: "absence_reasons" === $route.name,
                    },
                ],
            },
            {
                action: "mdi-bottle-tonic-plus",
                title: $i18n.t('module.medical'),
                access: true,
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "medical_configuration",
                        active: "medical_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.medical_center"),
                        action: "mdi-hospital-building",
                        link: "medical_centers",
                        active: "medical_centers" === $route.name,
                    },
                    {
                        title: $i18n.t("module.medical_reason"),
                        action: "mdi-hospital-marker",
                        link: "medical_reasons",
                        active: "medical_reasons" === $route.name,
                    },
                ],
            },
            {
                action: "mdi-account-school",
                title: $i18n.t("module.training"),
                access: securityStore.authorities['READ_TRAINING_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "training_requests_configuration",
                        active: "training_requests_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.training_school"),
                        action: "mdi-school",
                        link: "schools",
                        active: "schools" === $route.name,
                    },
                    {
                        title: $i18n.t("module.training_catalog"),
                        action: "mdi-book-cog",
                        link: "catalogs",
                        active: "catalogs" === $route.name,
                    }
                ],
            },
            {
                action: "mdi-puzzle-star-outline",
                title: $i18n.t("module.evaluation_worker"),
                access: securityStore.authorities['READ_EVALUATION_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "evaluation_plans_configuration",
                        active: "evaluation_plans_configuration" === $route.name,
                    },
                    {
                        title: "Compétence",
                        action: "mdi-hammer-wrench",
                        active: [
                            "evaluation_skill_phases",
                            "evaluation_skill_catalog",
                            "evaluation_skill_gravities",
                            "evaluation_skill_criterion_category",
                            "evaluation_skill_criterion",
                            "evaluation_skill_files",
                        ].includes($route.name),
                        subGroup: true,
                        items: [
                            {
                                title: $i18n.t("module.evaluation_skill_phases"),
                                action: "mdi-stairs",
                                link: "evaluation_skill_phases",
                                active: "evaluation_skill_phases" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_skill_catalog"),
                                action: "mdi-book-open-page-variant",
                                link: "evaluation_skill_catalog",
                                active: "evaluation_skill_catalog" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_gravities"),
                                action: "mdi-hydraulic-oil-level",
                                link: "evaluation_skill_gravities",
                                active: "evaluation_skill_gravities" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion_category"),
                                action: "mdi-shape",
                                link: "evaluation_skill_criterion_category",
                                active: "evaluation_skill_criterion_category" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion"),
                                action: "mdi-filter-cog",
                                link: "evaluation_skill_criterion",
                                active: "evaluation_skill_criterion" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_file"),
                                action: "mdi-form-dropdown",
                                link: "evaluation_skill_files",
                                active: "evaluation_skill_files" === $route.name,
                            },
                        ]
                    },
                    {
                        title: "Performance",
                        action: "mdi-speedometer",
                        active: [
                            "evaluation_performance_phases",
                            "evaluation_performance_file_models",
                            "evaluation_performance_gravities",
                            "evaluation_performance_criterion_category",
                            "evaluation_performance_criterion",
                            "evaluation_performance_files",
                        ].includes($route.name),
                        subGroup: true,
                        items: [
                            {
                                title: $i18n.t("module.evaluation_performance_phases"),
                                action: "mdi-stairs",
                                link: "evaluation_performance_phases",
                                active: "evaluation_performance_phases" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_performance_file_models"),
                                action: "mdi-file-document",
                                link: "evaluation_performance_file_models",
                                active: "evaluation_performance_file_models" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_gravities"),
                                action: "mdi-hydraulic-oil-level",
                                link: "evaluation_performance_gravities",
                                active: "evaluation_performance_gravities" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion_category"),
                                action: "mdi-shape",
                                link: "evaluation_performance_criterion_category",
                                active: "evaluation_performance_criterion_category" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion"),
                                action: "mdi-filter-cog",
                                link: "evaluation_performance_criterion",
                                active: "evaluation_performance_criterion" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_performance_files"),
                                action: "mdi-form-dropdown",
                                link: "evaluation_performance_files",
                                active: "evaluation_performance_files" === $route.name,
                            },
                        ]
                    },
                    {
                        title: "Recrutement",
                        action: "mdi-account-convert",
                        active: [
                            "evaluation_recruitment_gravities",
                            "evaluation_recruitment_criterion_category",
                            "evaluation_recruitment_criterion",
                            "evaluation_recruitment_files",
                        ].includes($route.name),
                        subGroup: true,
                        items: [
                            {
                                title: $i18n.t("module.evaluation_gravities"),
                                action: "mdi-hydraulic-oil-level",
                                link: "evaluation_recruitment_gravities",
                                active: "evaluation_recruitment_gravities" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion_category"),
                                action: "mdi-shape",
                                link: "evaluation_recruitment_criterion_category",
                                active: "evaluation_recruitment_criterion_category" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion"),
                                action: "mdi-filter-cog",
                                link: "evaluation_recruitment_criterion",
                                active: "evaluation_recruitment_criterion" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_file"),
                                action: "mdi-form-dropdown",
                                link: "evaluation_recruitment_files",
                                active: "evaluation_recruitment_files" === $route.name,
                            },
                        ]
                    },
                    {
                        title: "Formation - Chaud",
                        action: "mdi-fire-circle",
                        active: [
                            "evaluation_training_hot_gravities",
                            "evaluation_training_hot_criterion_category",
                            "evaluation_training_hot_criterion",
                            "evaluation_training_hot_files",
                        ].includes($route.name),
                        subGroup: true,
                        items: [
                            {
                                title: $i18n.t("module.evaluation_gravities"),
                                action: "mdi-hydraulic-oil-level",
                                link: "evaluation_training_hot_gravities",
                                active: "evaluation_training_hot_gravities" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion_category"),
                                action: "mdi-shape",
                                link: "evaluation_training_hot_criterion_category",
                                active: "evaluation_training_hot_criterion_category" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion"),
                                action: "mdi-filter-cog",
                                link: "evaluation_training_hot_criterion",
                                active: "evaluation_training_hot_criterion" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_file"),
                                action: "mdi-form-dropdown",
                                link: "evaluation_training_hot_files",
                                active: "evaluation_training_hot_files" === $route.name,
                            },
                        ]
                    },
                    {
                        title: "Formation - Froid",
                        action: "mdi-snowflake",
                        active: [
                            "evaluation_training_cold_gravities",
                            "evaluation_training_cold_criterion_category",
                            "evaluation_training_cold_criterion",
                            "evaluation_training_cold_files",
                        ].includes($route.name),
                        subGroup: true,
                        items: [
                            {
                                title: $i18n.t("module.evaluation_gravities"),
                                action: "mdi-hydraulic-oil-level",
                                link: "evaluation_training_cold_gravities",
                                active: "evaluation_training_cold_gravities" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion_category"),
                                action: "mdi-shape",
                                link: "evaluation_training_cold_criterion_category",
                                active: "evaluation_training_cold_criterion_category" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_criterion"),
                                action: "mdi-filter-cog",
                                link: "evaluation_training_cold_criterion",
                                active: "evaluation_training_cold_criterion" === $route.name,
                            },
                            {
                                title: $i18n.t("module.evaluation_file"),
                                action: "mdi-form-dropdown",
                                link: "evaluation_training_cold_files",
                                active: "evaluation_training_cold_files" === $route.name,
                            },
                        ]
                    },
                ]
            },
            {
                action: "mdi-cloud-sync",
                title: $i18n.t("module.document"),
                access: securityStore.authorities['READ_DOCUMENT_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.template"),
                        action: "mdi-page-layout-body",
                        link: "templates",
                        active: "templates" === $route.name,
                    },
                    {
                        title: $i18n.t("module.header_template"),
                        action: "mdi-page-layout-header",
                        link: "header_templates",
                        active: "header_templates" === $route.name,
                    },
                    {
                        title: $i18n.t("module.footer_template"),
                        action: "mdi-page-layout-footer",
                        link: "footer_templates",
                        active: "footer_templates" === $route.name,
                    },
                    {
                        title: $i18n.t("module.personalized_variable"),
                        action: "mdi-sigma",
                        link: "personalized_variables",
                        active: "personalized_variables" === $route.name,
                    },
                ]
            },
            {
                action: "mdi-cctv",
                title: "Controle",
                access: securityStore.authorities['READ_NOTIFICATION_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "alarms_configuration",
                        active: "alarms_configuration" === $route.name,
                    },
                    {
                        title: "Notifications",
                        action: "mdi-bell-cog",
                        link: "alarms",
                        active: "alarms" === $route.name,
                    },
                    {
                        title: $i18n.t("module.control_program"),
                        action: "mdi-calendar-filter",
                        link: "control_programs",
                        active: "control_programs" === $route.name,
                    },
                    {
                        title: $i18n.t("module.issue"),
                        action: "mdi-bug",
                        link: "control_issues",
                        active: "issues" === $route.name,
                    },
                ],
            },
            {
                action: "mdi-cog-outline",
                title: "Sécurité",
                access: securityStore.authorities['READ_PRIVILEGE_PARAM'],
                items: [
                    {
                        title: $i18n.t("module.configuration"),
                        action: "mdi-cog-outline",
                        link: "users_configuration",
                        active: "users_configuration" === $route.name,
                    },
                    {
                        title: $i18n.t("module.roles"),
                        action: "mdi-account-group-outline",
                        link: "roles",
                        active: "roles" === $route.name,
                    },
                    {
                        title: $i18n.t("module.users"),
                        action: "mdi-account-multiple-check-outline",
                        link: "users",
                        active: "users" === $route.name,
                    }
                ],
            },
        ]);

        function goTo(link) {
            $router.push({name: link})
        }

        onMounted(() => {
            if ($route.name === "parameters") {
                $router.push({name: items.value[0].items[0].link});
            }
        });

        return {
            items,
            goTo,
        }
    }
};
</script>

<template>
    <div>
        <v-container fluid>
            <v-tabs
                class="elevation-15"
                background-color="white"
                color="teal"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
            >
                <template v-for="(item, index) in items">
                    <v-menu
                        offset-y
                        v-model="item.menu"
                        v-if="item.access"
                        :key="`b-${index}`"
                    >
                        <template v-slot:activator="{ on }">
                            <v-tab v-on="on">
                                <v-icon left v-text="item.action"></v-icon>
                                {{ item.title }}
                            </v-tab>
                            <!--<v-btn text v-on="on" :color="item.items.some(t => t.active === true) ? 'teal': ''">
                                <v-icon left v-text="item.action"></v-icon>
                                {{ item.title }}
                            </v-btn>-->
                        </template>
                        <v-list dense nav>
                            <template v-for="(child, indey) in item.items">
                                <v-menu
                                    v-if="child.subGroup && child.items.length > 0"
                                    offset-x
                                    open-on-hover
                                    right
                                    :key="`group-l-${indey}`"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-list-item v-bind="attrs" v-on="on">
                                            <v-icon
                                                left
                                                v-text="child.action"
                                                :color="child.active ? 'teal': ''"
                                                class="mr-8"
                                            ></v-icon>
                                            <span :class="child.active ? 'teal--text': ''">
                                            {{ child.title }}
                                        </span>
                                        </v-list-item>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(sub, idenz) in child.items"
                                            :key="`sub-l-${idenz}`"
                                            @click="() => {
                                            item.menu = false;
                                            goTo(sub.link);
                                        }"
                                        >
                                            <v-icon
                                                left
                                                v-text="sub.action"
                                                :color="sub.active ? 'teal': ''"
                                                class="mr-8"
                                            ></v-icon>
                                            <span :class="sub.active ? 'teal--text': ''">
                                            {{ sub.title }}
                                        </span>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-list-item
                                    v-else
                                    :key="`l-${indey}`"
                                    @click="goTo(child.link)"
                                >
                                    <v-icon
                                        left
                                        v-text="child.action"
                                        :color="child.active ? 'teal': ''"
                                        class="mr-8"
                                    ></v-icon>
                                    <span :class="child.active ? 'teal--text': ''">
                                    {{ child.title }}
                                </span>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </template>
            </v-tabs>
        </v-container>

        <v-divider/>
        <transition name="scale-transition" hide-on-leave>
            <router-view/>
        </transition>
    </div>
</template>